import React, { Component } from 'react';
import FormCreate from './FormCreate'
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import FormCreateFormatDuplicateItem from './FormatDuplicationItem/FormCreate';
import FormCreateCondition from './FormatDuplicationCondition/FormCreate';


class Index extends Component {
    constructor(props) {
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            modal: false,
            modeEdit: false,
            showTable: false,
            ErrorValues: true,
            format_duplication_item_id: "",
            conditionCreateForId: "",
            conditionEditId: "",

            there_is_format_subform_targets: false,
            there_is_format_subform_sources: false,

            form: {
                format_id: this.props.format.id,
                format_source_id: "",
                question_subform_id: "",
                format_subform_source_id: "",
                format_subform_target_id: ""
            },

            formCreateFormatDuplicateItem: {
                format_duplication_id: "", 
                question_source_id: "", 
                question_target_id: ""
            },

            selectedOption: {
                label: "Selecione un formato",
                format_source_id: ""
            },

            selectedOptionQuestion: {
                label: "Selecione una pregunta",
                question_subform_id: "",
            },

            selectedOptionFormatSubFormSource: {
                label: "Seleccione un formato",
                format_subform_source_id: ""
            },

            selectedOptionFormatSubFormTarget: {
                label: "Seleccione un formato",
                format_subform_target_id: ""
            },

            questions: [],
            format_subform_sources: [],
            format_subform_targets: []
        }
    }

    messageSuccess = (response) => {
        Swal.fire({
            position: "center",
            type: `${response.type}`,
            title: `${response.success}`,
            showConfirmButton: false,
            timer: 1500,
        });
    };

    HandleChange = (e) => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value,
            }
        });
    }

    toogle = (from) => {
        if (from == "new") {
            this.setState({ modal: true })
            this.clearValues();
        } else {
            this.setState({ modal: false })
            this.clearValues();
        }
    }

    //add items
    updateData = (data) => {
        this.setState({
            data: [...this.state.data, data],
        })
    }

    //add items
    updateDataFormatDuplicationItem = (format_duplication_id, data) => {
        this.setState({
            data: this.state.data.map(item => {
                if (format_duplication_id === item.id) {
                    return {
                        ...item,
                        format_duplication_items: [...item.format_duplication_items, data],
                    }
                }
                return item;
            })
        })
    }

    updateItemFormatDuplicationItem = (register) => {
        this.setState({
            data: this.state.data.map(item => {
                if (register.format_duplication_id === item.id) {
                    return {
                        ...item,
                        format_duplication_items: item.format_duplication_items.map(format_duplication_item => {
                            if (register.id === format_duplication_item.id) {
                                return {
                                    ...format_duplication_item,
                                    question_source: register.question_source,
                                    question_target: register.question_target
                                }
                            }
                            return format_duplication_item;
                        })
                    }
                }
                return item;
            })
        })
    }

    //add update
    updateItem = format_duplication => {
        this.setState({
            data: this.state.data.map(item => {
                if (format_duplication.id === item.id) {
                    return {
                        ...item,
                        format_source: format_duplication.format_source,
                        question_subform: format_duplication.question_subform
                    }
                }
                return item;
            })
        });
    }

    clearValues = () => {
        this.setState({
            modeEdit: false,
            ErrorValues: true,
            there_is_format_subform_sources: false,

            form: {
                format_id: this.props.format.id,
                format_source_id: "",
                question_subform_id: "",
                format_subform_source_id: "",
                format_subform_target_id: ""
            },

            selectedOption: {
                label: "Selecione un formato",
                format_source_id: ""
            },

            selectedOptionQuestion: {
                label: "Selecione una pregunta",
                question_subform_id: "",
            },

            selectedOptionFormatSubFormSource: {
                label: "Seleccione un formato",
                format_subform_source_id: ""
            },

            selectedOptionFormatSubFormTarget: {
                label: "Seleccione un formato",
                format_subform_target_id: ""
            },

            format_subform_sources: []
        })
    }

    componentDidMount = () => {
        this.loadData();
        this.loadDataFormatSubFormTargets();
    }

    selectConfiguration = () => {
        let array = []

        this.props.steps_questions.map((item) => (
            array.push({ label: item.question, value: item.id })
        ))

        this.setState({
            questions: array,
        })
    }

    loadData = () => {
        fetch(`/formatos/get_format_duplications/${this.props.format.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.setState({
                data: data.data,
                isLoaded: false
            });
        });
    }

    loadDataSelects = () => {
        fetch(`/formatos/data_questions/${this.props.format.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                let array = []

                data.steps_questions.map((item) => (
                    array.push({ label: item.question, value: item.id })
                ))

                this.setState({
                    questions: array,
                    modal: true
                });
            });
    }

    validationForm = () => {
        if (this.state.form.format_source_id != "" &&
            this.state.form.format_subform_source_id != "" &&
            this.state.form.format_subform_target_id != "" &&
            this.state.form.question_subform_id != ""
        ) {
            this.setState({ ErrorValues: true })
            return true
        } else {
            this.setState({ ErrorValues: false })
            return false
        }
    }

    HandleClick = () => {
        if (this.validationForm()) {
            if (this.state.modeEdit) {
                fetch(`/formatos/format_duplications/${this.state.format_association_id}`, {
                    method: 'PATCH', // or 'PUT'
                    body: JSON.stringify(this.state.form), // data can be `string` or {object}!
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })

                    .then(res => res.json())
                    .catch(error => console.error("Error:", error))
                    .then(data => {
                        this.updateItem(data.register)
                        this.clearValues();
                        this.setState({ modal: false })
                    });
            } else {
                fetch(`/formatos/format_duplications`, {
                    method: 'POST', // or 'PUT'
                    body: JSON.stringify(this.state.form), // data can be `string` or {object}!
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(res => res.json())
                    .catch(error => console.error("Error:", error))
                    .then(data => {
                        this.updateData(data.register)
                        this.clearValues();
                        this.setState({ modal: false, showTable: true })
                    });
            }
        }
    }


    editFormatDuplicate = (format_association) => {
        this.loadDataFormatSubFormSources(format_association.format_source.id);
        this.setState({
            modal: true,
            modeEdit: true,
            format_association_id: format_association.id,

            form: {
                format_source_id: format_association.format_source.id,
                question_subform_id: format_association.question_subform != null ? format_association.question_subform.id : "",
                format_subform_source_id: format_association.format_subform_source != null ? format_association.format_subform_source.id : "",
                format_subform_target_id: format_association.format_subform_target != null ? format_association.format_subform_target.id : "",
            },

            selectedOption: {
                label: `${format_association.format_source.name}`,
                format_source_id: format_association.format_source.id,
            },

            selectedOptionQuestion: {
                label: `${format_association.question_subform != null ? format_association.question_subform.question : "Selecione una pregunta"}`,
                question_subform_id: format_association.question_subform != null ? format_association.question_subform.id : "",
            },

            selectedOptionFormatSubFormSource: {
                label: `${format_association.format_subform_source != null ? format_association.format_subform_source.name : "Selecione una pregunta"}`,
                format_subform_source_id: format_association.format_subform_source != null ? format_association.format_subform_source.id : "",
            },

            selectedOptionFormatSubFormTarget: {
                label: `${format_association.format_subform_target != null ? format_association.format_subform_target.name : "Selecione una pregunta"}`,
                format_subform_target_id: format_association.format_subform_target != null ? format_association.format_subform_target.id : "",
            }
        })
    }

    editFormatDuplicateItem = (format_duplication_item) => {
        this.setState({
            format_duplication_item_id: format_duplication_item.id,

            formCreateFormatDuplicateItem: {
                format_duplication_id: "", 
                question_source_id: format_duplication_item.question_source.value, 
                question_target_id: format_duplication_item.question_target.value, 
            },
        })
    }

    clearFormatDuplicateItemValues = () => {
        this.setState({
            format_duplication_item_id: "",
            formCreateFormatDuplicateItem: {
                format_duplication_id: "", 
                question_source_id: "", 
                question_target_id: "", 
            },
        })
    }

    deleteFormatDuplicate = id => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡El registro será eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`/formatos/format_duplications/${id}`, {
                    method: "delete",
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                .then(response => response.json())
                .then(response => {
                    this.loadData()
                    this.messageSuccess(response)
                });
            }
        });
    };


    deleteFormatDuplicateItem = (id) => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡El registro será eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`/formatos/format_duplication_items/${id}`, {
                    method: "delete",
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                .then(response => response.json())
                .then(response => {
                    this.loadData()
                    this.messageSuccess(response)
                });
            }
        });
    }

    loadDataFormatSubFormSources = (format_source_id) => {
        fetch(`/formatos/get_format_source_format_associations/${format_source_id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.setState({
                there_is_format_subform_sources: (data.data.length >= 1 ? true : false),
                format_subform_sources: data.data,
            });
        });
    }

    loadDataFormatSubFormTargets = () => {
        fetch(`/formatos/get_format_source_format_associations/${this.props.format.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.setState({
                there_is_format_subform_targets: (data.data.length >= 1 ? true : false),
                format_subform_targets: data.data,
            });
        });
    }

    handleChangeAutocomplete = selectedOption => {
        this.loadDataFormatSubFormSources(selectedOption.value);
        this.setState({
            selectedOption,
            form: {
                ...this.state.form,
                format_source_id: selectedOption.value,
                format_subform_source_id: ""
            },

            selectedOptionFormatSubFormSource: {
                label: "",
                format_subform_source_id: ""
            },
        });
    };

    handleChangeAutocompleteFormatSubFormSource = selectedOptionFormatSubFormSource => {
        this.setState({
            selectedOptionFormatSubFormSource,
            form: {
                ...this.state.form,
                format_subform_source_id: selectedOptionFormatSubFormSource.value
            }
        });
    };


    handleChangeAutocompleteFormatSubFormTarget = selectedOptionFormatSubFormTarget => {
        this.setState({
            selectedOptionFormatSubFormTarget,
            form: {
                ...this.state.form,
                format_subform_target_id: selectedOptionFormatSubFormTarget.value
            }
        });
    };

    handleChangeAutocompleteQuestions = selectedOptionQuestion => {
        this.setState({
            selectedOptionQuestion,
            form: {
                ...this.state.form,
                question_subform_id: selectedOptionQuestion.value
            }
        });
    };

    handleClickCreateItem = (format_duplication) => {
        this.setState({
            formCreateFormatDuplicateItem: {
                ...this.state.formCreateFormatDuplicateItem,
                format_duplication_id: format_duplication.id
            }
        })
    }

    handleChangeFormatDuplicateItem = (fieldOrObj, value) => {
        if (typeof fieldOrObj === 'object') {
            // Support passing multiple fields: { question_source_id: 123, question_target_id: "" }
            this.setState(prev => ({
                formCreateFormatDuplicateItem: { ...prev.formCreateFormatDuplicateItem, ...fieldOrObj }
            }));
        } else {
            this.setState(prev => ({
                formCreateFormatDuplicateItem: { ...prev.formCreateFormatDuplicateItem, [fieldOrObj]: value }
            }));
        }
    }

    // === Condition CRUD ===
    handleConditionCreated = (dupId, register) => {
        this.setState({
            conditionCreateForId: "",
            data: this.state.data.map(d => {
                if (d.id === dupId) {
                    return { ...d, format_duplication_conditions: [...(d.format_duplication_conditions || []), register] };
                }
                return d;
            })
        });
    }

    handleConditionUpdated = (dupId, register) => {
        this.setState({
            conditionEditId: "",
            data: this.state.data.map(d => {
                if (d.id === dupId) {
                    return {
                        ...d,
                        format_duplication_conditions: (d.format_duplication_conditions || []).map(c =>
                            c.id === register.id ? register : c
                        )
                    };
                }
                return d;
            })
        });
    }

    deleteCondition = (dupId, conditionId) => {
        Swal.fire({ title: "Eliminar condicion?", type: "warning", showCancelButton: true, confirmButtonText: "Si" }).then(result => {
            if (result.value) {
                fetch(`/formatos/format_duplication_conditions/${conditionId}`, {
                    method: 'DELETE',
                    headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
                })
                .then(r => r.json())
                .then(data => {
                    Swal.fire({ position: "center", type: data.type, title: data.success, showConfirmButton: false, timer: 1500 });
                    this.setState({
                        data: this.state.data.map(d => {
                            if (d.id === dupId) {
                                return { ...d, format_duplication_conditions: (d.format_duplication_conditions || []).filter(c => c.id !== conditionId) };
                            }
                            return d;
                        })
                    });
                });
            }
        });
    }

    render() {
        const styeleIcons = {
            fontSize: "16px",
            color: "#3f69d8",
            cursor: "pointer",
        }

        return (
            <React.Fragment>
                <Modal isOpen={this.props.modal} toggle={this.props.toggle} className="modal-dialog-centered modal-lg" backdrop={this.props.backdrop}>
                    <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>

                    <ModalBody>

                        {this.state.modal && (
                            <FormCreate
                                backdrop={"static"}
                                modal={this.state.modal}
                                toggle={this.toogle}
                                title={this.state.modeEdit ? "Actualizar asociación" : "Crear asociación"}
                                nameBnt={this.state.modeEdit ? "Actualizar" : "Crear"}
                                modeEdit={this.state.modeEdit}

                                //form props
                                formValues={this.state.form}
                                onChangeForm={this.HandleChange}
                                submitForm={this.HandleClick}
                                errorValues={this.state.ErrorValues}

                                there_is_format_subform_sources={this.state.there_is_format_subform_sources}
                                there_is_format_subform_targets={this.state.there_is_format_subform_targets}

                                //select values
                                handleChangeAutocomplete={this.handleChangeAutocomplete}
                                selectedOption={this.state.selectedOption}
                                formatos={this.props.formatos}

                                //selct format_subform_source_id
                                selectedOptionFormatSubFormSource={this.state.selectedOptionFormatSubFormSource}
                                handleChangeAutocompleteFormatSubFormSource={this.handleChangeAutocompleteFormatSubFormSource}
                                format_subform_sources={this.state.format_subform_sources}

                                //select format_subform_target_id
                                selectedOptionFormatSubFormTarget={this.state.selectedOptionFormatSubFormTarget}
                                handleChangeAutocompleteFormatSubFormTarget={this.handleChangeAutocompleteFormatSubFormTarget}
                                format_subform_targets={this.state.format_subform_targets}

                                //select questions 
                                handleChangeAutocompleteQuestions={this.handleChangeAutocompleteQuestions}
                                selectedOptionQuestion={this.state.selectedOptionQuestion}
                                questions={this.state.questions}
                                format={this.props.format}
                            />
                        )}

                        <div className="col-md-12 mb-3 text-right pr-0">
                            {!this.state.modal && (
                                <button
                                    className="btn-shadow btn btn-info"
                                    onClick={() => this.loadDataSelects()}
                                >
                                    Abrir formulario
                                </button>
                            )}
                        </div>

                        {this.state.data.length >= 1 ? (
                            this.state.data.map((format_duplication, index) => (
                                <React.Fragment key={format_duplication.id}>
                                    <div className="card mb-3">
                                        <div style={{ display: "block", padding: '12px 16px', borderBottom: '1px solid #e5e7eb' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                                <span style={{ fontWeight: 600, fontSize: 14 }}>Configuracion de duplicación</span>
                                                <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                                                    <button className="btn btn-sm" onClick={() => this.editFormatDuplicate(format_duplication)}>
                                                        <i className="fas fa-pencil-alt" style={styeleIcons} />
                                                    </button>
                                                    <button className="btn btn-sm" onClick={() => this.deleteFormatDuplicate(format_duplication.id)}>
                                                        <i className="fas fa-trash-alt" style={styeleIcons} />
                                                    </button>
                                                </div>
                                            </div>

                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 24px' }}>
                                                <div>
                                                    <span style={{ fontSize: 11, color: '#999', display: 'block' }}>Formato fuente</span>
                                                    <span style={{ fontSize: 13, fontWeight: 500 }}>{format_duplication.format_source.name}</span>
                                                </div>
                                                <div>
                                                    <span style={{ fontSize: 11, color: '#999', display: 'block' }}>Subformulario fuente</span>
                                                    <span style={{ fontSize: 13, fontWeight: 500 }}>{format_duplication.format_subform_source.name}</span>
                                                </div>
                                                <div>
                                                    <span style={{ fontSize: 11, color: '#999', display: 'block' }}>Pregunta de vinculacion</span>
                                                    <span style={{ fontSize: 13, fontWeight: 500 }}>{format_duplication.question_subform.question}</span>
                                                </div>
                                                <div>
                                                    <span style={{ fontSize: 11, color: '#999', display: 'block' }}>Subformulario destino</span>
                                                    <span style={{ fontSize: 13, fontWeight: 500 }}>{format_duplication.format_subform_target.name}</span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* === Conditions Section === */}
                                        <div style={{ padding: '8px 16px', borderBottom: '1px solid #e5e7eb' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                                <span style={{ fontSize: 12, fontWeight: 600, color: '#666' }}>Condiciones ({(format_duplication.format_duplication_conditions || []).length})</span>
                                                <div>
                                                    {this.state.conditionCreateForId === format_duplication.id && (
                                                        <FormCreateCondition
                                                            isOpen={true}
                                                            target={`PopoverCreateCondition${format_duplication.id}`}
                                                            format_duplication={format_duplication}
                                                            formatId={this.props.format.id}
                                                            modeEdit={false}
                                                            existingConditionsCount={(format_duplication.format_duplication_conditions || []).length}
                                                            onCreated={(register) => this.handleConditionCreated(format_duplication.id, register)}
                                                            onClose={() => this.setState({ conditionCreateForId: "" })}
                                                        />
                                                    )}
                                                    <button
                                                        className="btn btn-info btn-sm"
                                                        id={`PopoverCreateCondition${format_duplication.id}`}
                                                        onClick={() => this.setState({ conditionCreateForId: format_duplication.id })}
                                                    >
                                                        <i className="fas fa-plus mr-1" /> Condicion
                                                    </button>
                                                </div>
                                            </div>
                                            {(format_duplication.format_duplication_conditions || []).length > 0 ? (
                                                <div style={{ fontSize: 13 }}>
                                                    {format_duplication.format_duplication_conditions.map((cond, idx) => (
                                                        <div key={cond.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', borderBottom: '1px solid #f0f0f0' }}>
                                                            {idx > 0 && (
                                                                <span style={{ fontSize: 11, fontWeight: 600, color: cond.conditional === 'O' ? '#e67e22' : '#3498db', minWidth: 24 }}>
                                                                    {cond.conditional === 'O' ? 'O' : 'Y'}
                                                                </span>
                                                            )}
                                                            {idx === 0 && <span style={{ minWidth: 24 }} />}
                                                            <span style={{ fontWeight: 500 }}>{cond.question_info.name}</span>
                                                            <span style={{ color: '#999', fontSize: 11 }}>{cond.operation}</span>
                                                            {cond.compare_mode && cond.compare_mode !== 'value' && cond.question_to_compare_info ? (
                                                                <span style={{ color: cond.compare_mode === 'question' ? '#8e44ad' : cond.compare_mode === 'parent_source' ? '#2980b9' : '#e67e22', fontWeight: 500 }}>
                                                                    [{cond.question_to_compare_info.name}]
                                                                    <span style={{ fontSize: 9, color: '#999', marginLeft: 4 }}>
                                                                        {cond.compare_mode === 'question' ? 'subform' : cond.compare_mode === 'parent_source' ? 'fmt. fuente' : 'fmt. actual'}
                                                                    </span>
                                                                </span>
                                                            ) : (
                                                                <span style={{ color: '#27ae60', fontWeight: 500 }}>"{cond.value && cond.value.includes(',') ? cond.value.split(',').join(' y ') : cond.value}"</span>
                                                            )}
                                                            <div style={{ marginLeft: 'auto', display: 'flex', gap: 4 }}>
                                                                {this.state.conditionEditId === cond.id && (
                                                                    <FormCreateCondition
                                                                        isOpen={true}
                                                                        target={`PopoverEditCondition${cond.id}`}
                                                                        format_duplication={format_duplication}
                                                                        formatId={this.props.format.id}
                                                                        modeEdit={true}
                                                                        condition={cond}
                                                                        onUpdated={(register) => this.handleConditionUpdated(format_duplication.id, register)}
                                                                        onClose={() => this.setState({ conditionEditId: "" })}
                                                                    />
                                                                )}
                                                                <button className="btn btn-sm p-0" id={`PopoverEditCondition${cond.id}`} onClick={() => this.setState({ conditionEditId: cond.id })}>
                                                                    <i className="fas fa-pencil-alt" style={{ ...styeleIcons, fontSize: 12 }} />
                                                                </button>
                                                                <button className="btn btn-sm p-0" onClick={() => this.deleteCondition(format_duplication.id, cond.id)}>
                                                                    <i className="fas fa-trash-alt" style={{ ...styeleIcons, fontSize: 12 }} />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div style={{ textAlign: 'center', padding: '8px 0', color: '#999', fontSize: 12 }}>
                                                    Sin condiciones — se duplicaran todos los items
                                                </div>
                                            )}
                                        </div>

                                        {/* === Field Mapping Section === */}
                                        <div style={{ padding: '8px 16px', background: '#f9fafb' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                                <span style={{ fontSize: 12, fontWeight: 600, color: '#666' }}>Mapeo de campos ({format_duplication.format_duplication_items.length})</span>
                                                <div>
                                                    {(this.state.formCreateFormatDuplicateItem.format_duplication_id == format_duplication.id) && (
                                                        <FormCreateFormatDuplicateItem
                                                            form={this.state.formCreateFormatDuplicateItem}
                                                            isOpen={this.state.formCreateFormatDuplicateItem.format_duplication_id == format_duplication.id}
                                                            modeEdit={false}
                                                            target={`PopoverCreateFormatDuplicateItem${format_duplication.id}`}
                                                            format={this.props.format}
                                                            format_duplication={format_duplication}
                                                            format_duplication_id={this.state.format_duplication_id}
                                                            handleChangeFormatDuplicateItem={this.handleChangeFormatDuplicateItem}
                                                            updateDataFormatDuplicationItem={this.updateDataFormatDuplicationItem}
                                                            clearFormatDuplicateItemValues={this.clearFormatDuplicateItemValues}
                                                        />
                                                    )}
                                                    <button
                                                        className="btn btn-info btn-sm"
                                                        id={`PopoverCreateFormatDuplicateItem${format_duplication.id}`}
                                                        onClick={() => this.handleClickCreateItem(format_duplication)}
                                                    >
                                                        <i className="fas fa-plus mr-1" /> Mapear campo
                                                    </button>
                                                </div>
                                            </div>
                                            {format_duplication.format_duplication_items.length >= 1 ? (
                                                <table style={{ width: '100%', fontSize: 13 }}>
                                                    <thead>
                                                        <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
                                                            <th style={{ padding: '6px 8px', fontWeight: 600, color: '#666', fontSize: 11 }}>Pregunta fuente</th>
                                                            <th style={{ padding: '6px 8px', width: 30 }}></th>
                                                            <th style={{ padding: '6px 8px', fontWeight: 600, color: '#666', fontSize: 11 }}>Pregunta destino</th>
                                                            <th style={{ padding: '6px 8px', width: 60 }}></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {format_duplication.format_duplication_items.map((item) => (
                                                            <tr key={item.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                                <td style={{ padding: '6px 8px' }}>{item.question_source.label}</td>
                                                                <td style={{ padding: '6px 8px', color: '#999' }}><i className="fas fa-arrow-right" style={{ fontSize: 10 }} /></td>
                                                                <td style={{ padding: '6px 8px' }}>{item.question_target.label}</td>
                                                                <td style={{ padding: '6px 8px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                                                                    {(this.state.format_duplication_item_id == item.id) && (
                                                                        <FormCreateFormatDuplicateItem
                                                                            form={this.state.formCreateFormatDuplicateItem}
                                                                            isOpen={this.state.format_duplication_item_id == item.id}
                                                                            modeEdit={true}
                                                                            target={`PopoverEditFormatDuplicateItem${item.id}`}
                                                                            format={this.props.format}
                                                                            format_duplication={format_duplication}
                                                                            format_duplication_item={item}
                                                                            handleChangeFormatDuplicateItem={this.handleChangeFormatDuplicateItem}
                                                                            updateItemFormatDuplicationItem={this.updateItemFormatDuplicationItem}
                                                                            clearFormatDuplicateItemValues={this.clearFormatDuplicateItemValues}
                                                                        />
                                                                    )}

                                                                    <button
                                                                        className="btn btn-sm p-0"
                                                                        id={`PopoverEditFormatDuplicateItem${item.id}`}
                                                                        onClick={() => this.editFormatDuplicateItem(item)}
                                                                    >
                                                                        <i className="fas fa-pencil-alt" style={{ ...styeleIcons, fontSize: 13 }} />
                                                                    </button>
                                                                    <button className="btn btn-sm p-0 ml-2" onClick={() => this.deleteFormatDuplicateItem(item.id)}>
                                                                        <i className="fas fa-trash-alt" style={{ ...styeleIcons, fontSize: 13 }} />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <div style={{ textAlign: 'center', padding: '16px 0', color: '#999', fontSize: 13 }}>
                                                    <i className="fas fa-link" style={{ fontSize: 18, marginBottom: 4, display: 'block' }} />
                                                    No hay campos mapeados. Haz clic en "Mapear campo" para agregar.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))
                        ) : (
                            <div className="card">
                                <div className="card-body text-center">
                                    <h4>No hay registros</h4>
                                </div>
                            </div>
                        )}

                        {/*<div className="card">
                            <div className="background-gray">
                                <table className="table " id="sampleTable">
                                    <thead style={{ borderTop: "hidden", borderBottom: "hidden", color: "gray" }}>
                                        <tr>
                                            <th>Formato</th>
                                            <th>Pregunta</th>
                                            <th className="text-right">Acciones</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.state.data.length >= 1 ? (
                                            this.state.data.map((format_duplication, index) => (
                                                <React.Fragment>
                                                    {index >= 1 ? <div className="mb-2"></div> : null}
                                                    <tr key={format_duplication.id} className="tr-table-task" style={{ borderLeft: `4px solid green` }}>

                                                        <td>{format_duplication.format_target ? format_duplication.format_target.name : ""}</td>
                                                        <td>{format_duplication.question_subform ? format_duplication.question_subform.question : ""}</td>
                                                        <td className="text-right">
                                                            {true && (
                                                                <UncontrolledDropdown className='btn-group'>
                                                                    <DropdownToggle className='btn-shadow btn btn-info'>
                                                                        <i className="fas fa-bars"></i>
                                                                    </DropdownToggle>
                                                                    <DropdownMenu className="dropdown-menu dropdown-menu-right">
                                                                        {true && (
                                                                            <DropdownItem
                                                                                className="dropdown-item"
                                                                                onClick={() => this.edit(format_duplication)}
                                                                            >
                                                                                Editar
                                                                            </DropdownItem>
                                                                        )}
                                                                        {true && (
                                                                            <DropdownItem
                                                                                onClick={() => this.delete(format_duplication.id)}
                                                                                className="dropdown-item"
                                                                            >
                                                                                Eliminar
                                                                            </DropdownItem>
                                                                        )}
                                                                    </DropdownMenu>
                                                                </UncontrolledDropdown>
                                                            )}
                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="8" className="text-center">
                                                    <div className="text-center mt-4 mb-4">
                                                        <h4>No hay registros</h4>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>*/}


                    </ModalBody>
                </Modal>
            </React.Fragment>
        );
    }
}

export default Index;